import { useState, useEffect, useCallback } from "react";
import "./businessAnalysis.css";
import { useUserAuth } from "../../context/UserAuthContext";
import Skeleton from "react-loading-skeleton";
import BannderDeciderContainer from "../vendorProfile/BannderDeciderContainer";
import axios from "axios";
import dayjs from "dayjs";

const BusinessAnalysis = () => {
  const [merchant, setMerchant] = useState();
  const [loading, setLoading] = useState(false);
  const { user, language, token } = useUserAuth();
  const [vendors, setVendors] = useState([]);
  

  const fetchVendors = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/manager/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendors(res.data.vendors);
    } catch (err) {
      console.log("Error fetching vendors:", err);
    }
  };
  
  const [stats, setStats] = useState({});
  const getManagerAnalytics = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/manager/analytics`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setStats(res.data?.data);
      //  setVendors(res.data.vendors);
    } catch (err) {
      console.log("Error fetching vendors:", err);
    }
  };
  useEffect(() => {
    if (!token) return;
    fetchVendors();
    getManagerAnalytics();
  }, [token]);
  // console.log('token', token);

  const merchant_id = user?.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const getSingleDocumentHandler = useCallback(
    async (merchant_id, setMerchant, setLoading) => {
      if (!merchant_id) return;
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${base_url}/api/v1/users/id/${merchant_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );       
        setMerchant(data?.data || {});
      } catch (error) {
        console.error("Error fetching merchant data:", error);
      } finally {
        setLoading(false);
      }
    },
    [base_url],
  );

  useEffect(() => {
    if (user && merchant_id) {
      getSingleDocumentHandler(merchant_id, setMerchant, setLoading);
    }
  }, [user, merchant_id, getSingleDocumentHandler]);



  return (
    <div className="page-wrapper">
      <div className="container-fluid profileHeader">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header" style={{background:'#0a0a0a'}}>
                    <h5 className="mb-0">Properties</h5>
                  </div>

                  <div className="card-body">
                    {loading ? (
                      <p>Loading...</p>
                    ) : vendors.length === 0 ? (
                      <p>No vendors found</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                          <thead className="table-dark">
                            <tr>
                              <th className="text-white">#</th>
                              <th className="text-white">Business Name</th>
                              <th className="text-white">Email</th>
                              <th className="text-white">Mobile</th>
                              <th className="text-white">City</th>
                              <th className="text-white">Onboarding</th>
                            </tr>
                          </thead>

                          <tbody>
                            {vendors.map((vendor, index) => (
                              <tr key={vendor.id}>
                                <td>{index + 1}</td>
                                <td>{vendor.business_name} &nbsp;
                                  <a href={vendor?.profile_link} target="_blank" rel="noreferrer">
                                    <i className="fa fa-link"></i>
                                  </a>
                                </td>
                                <td>{vendor.email}</td>
                                <td>{vendor.mobno}</td>
                                <td>{vendor.city_name}</td>
                                 <td>{dayjs(vendor.created_at).format('DD MMMM, YYYY')}</td>
                               
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-3 col-6">
                    <div className=" p-10  text-center total_card shadow-sm ">
                      <div className="data d-flex justify-content-center">
                        <h2>{stats.total_bookings || 0} </h2>
                      </div>
                      <p
                        className=" p-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                          color: "#000",
                        }}
                      >
                        {language === "en" ? "Received Queries" : "प्राप्त लीड"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className=" p-10  text-center total_card shadow-sm ">
                      <div className="data d-flex justify-content-center">
                        <h2>{stats.total_packages || 0}</h2>
                      </div>
                      <p
                        className=" p-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                          color: "#000",
                        }}
                      >
                        {language === "en" ? "Packages" : "पैकेज"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className=" p-10  text-center total_card shadow-sm ">
                      <div className="data d-flex justify-content-center">
                        <h2>{stats.total_products || 0} </h2>
                      </div>
                      <p
                        className=" p-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                          color: "#000",
                        }}
                      >
                        {language === "en" ? "Service" : "सेवाएं"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-6">
                    <div className=" p-10  text-center total_card shadow-sm ">
                      <div className="data d-flex justify-content-center">
                        <h2>{stats.total_ratings || 0} </h2>
                      </div>
                      <p
                        className=" p-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                          color: "#000",
                        }}
                      >
                        {language === "en" ? "Review" : "समीक्षा"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessAnalysis;
